module.exports = __webpack_public_path__ + "img/btn3.cd117fa4.png";